module.exports = __webpack_public_path__ + "static/media/zsolt-temesvary.b9e3df72.jpg";